// custome hook getLocationId. uses the UserStore and gets the user and returrs urser.locationId
import { UserContext } from "./User.provider";
import useStore from "../../helpers/useStore";
import { AccountDto, RoleDto } from "../../api-client";
import { useAccounts } from "./user.queries";

export const useLocationId = (): string | undefined => {
  const UserStore = useStore(UserContext);
  const { user } = UserStore;
  return user?.locationId;
};

export const useUserId = (): string | undefined => {
  const UserStore = useStore(UserContext);
  return UserStore.userId;
};

export const useUserBusinessId = (): string | undefined => {
  const UserStore = useStore(UserContext);
  const { user } = UserStore;
  return user?.business?.id;
};

export const useUserAccounts = (): AccountDto[] | undefined => {
  const locationId = useLocationId();
  const { data: accounts } = useAccounts(locationId);
  return accounts;
};

export const useUserRole = (): RoleDto[] | undefined => {
  const UserStore = useStore(UserContext);
  const { user } = UserStore;
  return user?.roles || [];
}
